
export default {
  name: 'GcButton',
  data() {
    return {
      className: 'gc__button',
    };
  },
  computed: {
    el() {
      if (this.href) return 'a';

      return 'button';
    },
    flatClassName() {
      return `${this.className}--flat`;
    },
    containedClassName() {
      return `${this.className}--contained`;
    },
    variantClassName() {
      if (this.flat) return this.flatClassName;

      return this.containedClassName;
    },
    disabledProperty() {
      if (this.type === 'disabled') return true;
      return false;
    },
  },
  props: {
    size: {
      type: String,
      default: 'large',
    },
    type: {
      type: String,
      default: 'default',
    },
    href: {
      type: String,
    },
    flat: {
      type: Boolean,
      default: false,
    },
    styleObject: {
      type: Object,
      default: null,
    },
  },
};
